module.exports = __webpack_public_path__ + "img/delays-and-time-response-bg.7e0ad260.jpg";